// @flow
import * as React from 'react';
import Link from 'components/Link';
import { setupLinkTracker } from 'utils/analytics';

const { useRef, useEffect } = React;

type Props = {
  eventName?: string,
  eventProperties?: Object,
  href: string,
  waitForHref?: boolean
};

const updateTracker = (eventName, eventProperties, linkRef) => {
  if (eventName && linkRef && linkRef.current) {
    return setupLinkTracker(eventName, eventProperties)(linkRef.current);
  }
};

const TrackedLink = ({ waitForHref, ...props }: Props) => {
  const linkRef = useRef(null);
  useEffect(
    () => {
      const clickHandler = updateTracker(
        props.eventName,
        props.eventProperties,
        linkRef
      );
      const el = linkRef.current;
      return () => {
        if (el && clickHandler) {
          el.removeEventListener('click', clickHandler);
        }
      };
    },
    [props.eventName, props.eventProperties]
  );
  return <Link key={props.eventName} {...props} ref={linkRef} />;
};

export const TrackedConditionalLink = ({
  link,
  children,
  ...props
}: {
  link: ?string,
  children: React.Node,
  'data-qa-id'?: string
}) =>
  link ? (
    <TrackedLink data-qa-id={props['data-qa-id']} href={link} {...props}>
      {children}
    </TrackedLink>
  ) : (
    children
  );

export default TrackedLink;
